import { CustomEventNames, EventTypes, logEvent } from 'features/analytics';

import { IDateOfBirth } from 'utils/form/types';

export const isDateOfBirthFilled = (dob: IDateOfBirth) => {
  return Boolean(dob.day && dob.month && dob.year);
};

export const getTermsEventName = (isSelected: boolean) => {
  return isSelected
    ? CustomEventNames.SIGN_UP_TERMS_CHECKED
    : CustomEventNames.SIGN_UP_TERMS_UNCHECKED;
};

export const logSignupFlowRedesignEvent = (
  eventName: CustomEventNames,
  attributes?: Record<string, boolean | string>
) => {
  if (attributes) {
    logEvent(eventName, EventTypes.Other, attributes);
    return;
  }

  logEvent(eventName, EventTypes.Other);
};
